import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { afterItems, beforeItems } from "../../data/content";
export function BeforeAfterSection() {
  return <section className="bg-white px-4 py-16 md:py-24" data-id="element-89" data-mp="3ahk5zrqa9uxp">
      <div className="mx-auto max-w-6xl" data-id="element-90" data-mp="3ffljzy8ur42b">
        <SectionHeading eyebrow="From uncertain assessments to a more structured process" title="You don’t necessarily need more tests. You need a better way to organize the information you collect." data-id="element-91" data-mp="3fgn0ii8n0irf" />

        <div className="mt-10 grid gap-5 md:grid-cols-2 md:gap-6" data-id="element-92" data-mp="3tev1r2cpi68e">
          <div className="rounded-3xl border-2 border-bad/25 bg-bad-soft p-5 md:p-7" data-id="element-93" data-mp="3tc8s8x699gnj">
            <div className="flex items-center gap-3 rounded-2xl bg-bad px-4 py-3" data-id="element-94" data-mp="267icry10t3h">
              <XIcon className="h-7 w-7 shrink-0 text-white" strokeWidth={3} aria-hidden="true" data-id="element-95" data-mp="pw1s30n1u1ji" />
              <h3 className="font-display text-lg font-black uppercase leading-tight text-white" data-id="element-96" data-mp="upw7hrvmfucs">
                Before: without a structured framework
              </h3>
            </div>
            <ul className="mt-5 space-y-4" data-id="element-97" data-mp="1xqcfdw08hfb6">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-98" data-mp="2cez58rnhlpgn">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-bad/15" data-id="element-99" data-mp="27nh4a3lgrovo">
                    <XIcon className="h-4 w-4 text-bad" strokeWidth={3} aria-hidden="true" data-id="element-100" data-mp="2ldsyc81lzxpg" />
                  </span>
                  <span className="text-base leading-snug text-ink" data-id="element-101" data-mp="2gehh6xxbyq7c">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border-2 border-good/25 bg-good-soft p-5 md:p-7" data-id="element-102" data-mp="2vafewkmwk2lo">
            <div className="flex items-center gap-3 rounded-2xl bg-good px-4 py-3" data-id="element-103" data-mp="2qbm635ik8zru">
              <CheckIcon className="h-7 w-7 shrink-0 text-white" strokeWidth={3} aria-hidden="true" data-id="element-104" data-mp="10z0pk4xt056g" />
              <h3 className="font-display text-lg font-black uppercase leading-tight text-white" data-id="element-105" data-mp="w1iea7wbddva">
                After: with Shoulder Assessment Blueprint™
              </h3>
            </div>
            <ul className="mt-5 space-y-4" data-id="element-106" data-mp="1ppol3qmngzxj">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-107" data-mp="1umwsqxa69lkj">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-good" data-id="element-108" data-mp="1znulg3st5y0a">
                    <CheckIcon className="h-4 w-4 text-white" strokeWidth={3} aria-hidden="true" data-id="element-109" data-mp="24lmex293ps6l" />
                  </span>
                  <span className="text-base font-medium leading-snug text-ink" data-id="element-110" data-mp="28mg0hoz2muwb">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-3xl text-center" data-id="element-111" data-mp="2id0wd4nd1lbj">
          <p className="text-lg text-muted" data-id="element-112" data-mp="2ndf5kq0p71b5">The difference isn’t about memorizing more examination procedures.</p>
          <p className="mt-3 text-balance font-display text-xl font-black uppercase leading-snug text-ink md:text-3xl" data-id="element-113" data-mp="2sbqgl42qbhuy">
            It’s about having a clearer framework for putting the information you already know into context.
          </p>
        </div>
        <div className="mt-10" data-id="element-114" data-mp="brwh32qn1ngo">
          <CtaButton label="I want a more structured approach" sub="One-time payment of $27 · Instant access · 7-day guarantee" data-id="element-115" data-mp="6qgtp40zn4v4" />
        </div>
      </div>
    </section>;
}